import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { ErrorNotification } from '@storeOld/reducers/notification'
import { useDispatch, useSelector } from 'react-redux'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { noop } from '@/helpers'
import { getFileUploader, isTooLargeToUpload } from '@/services/upload'
import {
  getTooLargeMessage,
  getUploadErrorMessage,
} from '@/services/uploadError'
import type { StorageItem } from '../types'

export const useContentAttach = () => {
  const dispatch = useDispatch()
  const projectId = useSelector(migrationProjectSelector.getProjectId)

  const onUpload = async (files: FileList): Promise<StorageItem[]> => {
    const file = files.item(0)

    if (!file) {
      return []
    }

    if (isTooLargeToUpload(file)) {
      dispatch(ErrorNotification(getTooLargeMessage()))
      return []
    }

    const uploader = getFileUploader(projectId)

    if (!uploader) {
      dispatch(ErrorNotification('Save the project before uploading files.'))
      return []
    }

    try {
      const item = await uploader(file, noop)
      sendGtmEvent(GtmTriggerName.EDITOR_UPLOAD)

      return [{ ...item, name: file.name }]
    } catch (error) {
      dispatch(ErrorNotification(getUploadErrorMessage(error)))

      // The editor does not catch rejected uploads. An empty result finishes the
      // attempt without inserting a file and lets the user select it again.
      return []
    }
  }

  return { onUpload }
}
